<template>
  <div v-if="sending"
       class="sending-comment"
  >
    Odesílám <i class="fas fa-sync-alt fa-spin"></i>
  </div>
  <div v-else
       class="new-comment"
  >
    <div
      :id="htmlId"
      class="asd-input div-input-like"
      contenteditable="true"
      @keypress="keypress"
    ></div>
  </div>
</template>

<script>
import { get } from 'lodash'
import Carret from 'CORE/utils/carret'
import uuid from 'uuid'

export default {
    name: 'CommentNew',
    props: {
        entityId: {
            type: String,
            required: true,
        },
        entityType: {
            type: String,
            required: true,
        },
        parentId: {
            type: String,
            required: false,
            default: _ => null,
        },
        initialText: {
            type: String,
            required: false,
            default: _ => null,
        },
    },
    data: function() {
        return {
            commentText: '',
            sending: false,
        }
    },
    computed: {
        htmlId() {
            return `new-comment-${uuid()}`
        },
    },
    watch: {
        initialText(newVal, oldVal) {
            console.info(newVal, oldVal)
            const el = document.getElementById(this.htmlId)
            const carret = new Carret(el)
            el.innerHTML = `${newVal}&nbsp;`
            carret.setPos(2)
        },
    },
    methods: {
        keypress(e) {
            const content = get(e, 'target.innerHTML', '')
            this.commentText = content
            // console.info(e)
            if (e.key === 'Enter' && e.shiftKey === false) {
                e.returnValue = false
                this.createComment()
            }
        },
        async createComment() {
            try {
                this.sending = true
                const data = {
                    entity: this.entityId,
                    parent: this.parentId,
                    text: this.commentText,
                    entityType: this.entityType,
                }
                await this.$store.dispatch('addComment', data)
                await this.$store.dispatch('commentsLoad')
                this.commentText = ''
            } catch (e) {
                console.error(e)
            } finally {
                this.sending = false
            }
        },
    },
}
</script>

<style lang="scss" scoped>
    .div-input-like {
        min-height: 2.5rem;
        height: auto;
    }
    .sending-comment {
        color: firebrick;
        font-size: 75%;
        font-weight: bold;
    }
</style>
